import { createContext, useContext } from 'react';
import { CarouselContextValue } from './carousel.types';

export const CarouselContext = createContext<CarouselContextValue | null>(null);

export const useCarouselContext = () => {
  const ctx = useContext(CarouselContext);

  if (!ctx) {
    throw new Error('useCarousel должен быть внутри <Carousel.Root>');
  }

  return ctx;
};
